import { css } from 'styled-components';
export default {
    gotham: {
        light: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: normal;
      font-weight: 300;
    `,
        lightItalic: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: italic;
      font-weight: 300;
    `,
        regular: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: normal;
      font-weight: 400;
    `,
        regularItalic: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: italic;
      font-weight: 400;
    `,
        medium: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: normal;
      font-weight: 500;
    `,
        mediumItalic: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: italic;
      font-weight: 500;
    `,
        bold: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: normal;
      font-weight: 700;
    `,
        boldItalic: css `
      font-family: 'HCo Gotham', sans-serif;
      font-style: italic;
      font-weight: 700;
    `,
    },
};
